import React from "react";
import { IViewUserRequestModalPlanSummaryProps } from "./interface";
import { ZIcon, ZTypography } from "@atoms";
import { EColors } from "@atoms/ZColors/interface";
import { EIcons } from "@atoms/ZIcon/interface";
import { EFontWeights } from "@atoms/ZTypography/interface";
import { Col, Row } from "antd";
import { customCurrencyFormatter } from "@/Utils/Currency";

const ZViewUserRequestModalPlanSummary: React.FC<
	IViewUserRequestModalPlanSummaryProps
> = props => {
	const billingAmount = props.plan?.next_billing_amount ?? 0;
	return (
		<div className="p-4 border-gray-4 border border-solid rounded-md">
			<div className="flex">
				<div className="w-12">
					<ZIcon
						color={EColors.BLUE}
						colorVariant={6}
						name={EIcons.WARNINGCIRCLE}
					/>
				</div>
				<div className="w-full">
					<ZTypography.ZText
						className="block"
						colorVariant={9}
						level={2}
						weight={EFontWeights.MEDIUM}
					>
						Plan summary
					</ZTypography.ZText>
					<div className="my-2">
						<div className="flex justify-between">
							<ZTypography.ZText colorVariant={8} level={1}>
								Selected Plan
							</ZTypography.ZText>
							<ZTypography.ZText colorVariant={8} level={1}>
								{props.plan?.plan}
							</ZTypography.ZText>
						</div>
						<div className="flex justify-between">
							<ZTypography.ZText colorVariant={8} level={1}>
								Number of Seats
							</ZTypography.ZText>
							<ZTypography.ZText colorVariant={8} level={1}>
								{props.plan?.total_seats}
							</ZTypography.ZText>
						</div>
						<div className="flex justify-between">
							<ZTypography.ZText colorVariant={8} level={1}>
								Monthly Amount
							</ZTypography.ZText>
							<ZTypography.ZText
								colorVariant={8}
								level={1}
								weight={EFontWeights.MEDIUM}
							>
								{props.plan?.next_billing_amount
									? customCurrencyFormatter(
											Number(billingAmount.toFixed(2)),
											props.plan.currency
									  )
									: "--"}
							</ZTypography.ZText>
						</div>
					</div>
					<Row className="mb-6">
						<Col className="bg-gold-1 p-4 rounded border border-solid border-gold-3">
							<div className="grid grid-flow-col">
								<ZIcon
									name={EIcons.WARNINGCIRCLE}
									size="sm"
									colorVariant={6}
									color={EColors.GOLD}
									className="ml-2 mr-2 mt-1"
								/>
								<ZTypography.ZText colorVariant={8} level={1}>
									{`Approximate prorated invoice of ${customCurrencyFormatter(
										Number(
											props.plan?.prorated_amount?.toFixed(
												2
											)
										),
										props.plan?.currency
									)} will be generated immediately for the new user addition. An invoice of ${customCurrencyFormatter(
										Number(billingAmount.toFixed(2)),
										props.plan?.currency
									)} will be generated for the next billing cycle.`}
								</ZTypography.ZText>
							</div>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default ZViewUserRequestModalPlanSummary;
